<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const props = defineProps({

    ruta: {
        type: String,
        required: true,
    },

    reloaddatatable: {
        type: Boolean,
        required: false,
        default: true,
    }
});

const closeAction = async (id) => {
    router.push({ name: props.ruta, query: { reload: props.reloaddatatable } })
};
</script>

<template>
    <div class="d-flex sticky-top">
        <div class="p-0 flex-grow-1">
            <i role="button" class="fa-solid fa-circle-xmark fs-4 py-1 fa-fw text-danger float-end" @click="closeAction"></i>
        </div>
    </div>
</template>